import {
  getCookie as getCookieClient,
  setCookie,
} from 'cookies-next/client';
import { getCookie as getCookieServer } from 'cookies-next/server';

import { type ListingCardView } from '@/features/listing/types/listing-types';
import { SECONDS } from '@/shared/constants/time-constants';
import {
  type CookieGetData,
  type CookieReturnValue,
} from '@/shared/types/cookies-types';

const cookieName = 'listingView';

export function setCookieListingView(isHideAppBanner: ListingCardView): void {
  setCookie(cookieName, isHideAppBanner, {
    maxAge: SECONDS.YEAR,
    path: '/',
  });
}

export function getCookieListingView<IsServer extends boolean = false>(cookieOptions?: CookieGetData<IsServer>): CookieReturnValue<IsServer, ListingCardView> | null {
  if (cookieOptions?.isServer) {
    return (async () => {
      const cookie = await getCookieServer(cookieName, cookieOptions.options);

      if (cookie) {
        return cookie as ListingCardView;
      }

      return null;
    })() as CookieReturnValue<IsServer, ListingCardView>; // Ensure proper type casting for Promise
  }

  return getCookieClient(cookieName) as CookieReturnValue<IsServer, ListingCardView>;
}
